export const SET_DEBUG_MODE = 'SET_DEBUG_MODE'
export const SW_SET_UPDATE_AVAIL = 'SW_SET_UPDATE_AVAIL'
export const SW_SET_UPDATE_READY = 'SW_SET_UPDATE_READY'
export const SW_SET_IS_UPDATING = 'SW_SET_IS_UPDATING'
export const SW_SET_REGISTRATION = 'SW_SET_REGISTRATION'

export const ACCT_SET_ACCOUNTS = 'ACCT_SET_ACCOUNTS'
export const ACCT_UPDATE_SELECTED_ACCOUNT_KEY = 'ACCT_UPDATE_SELECTED_ACCOUNT_KEY'
export const ACCT_SET_ERRORS = 'ACCT_SET_ERRORS'
export const ACCT_SET_ERRORS_CC_FORM = 'ACCT_SET_ERRORS_CC_FORM'
export const ACCT_SET_ERRORS_ECHECK_FORM = 'ACCT_SET_ERRORS_ECHECK_FORM'
export const ACCT_SET_ERRORS_POST_PAYMENT = 'ACCT_SET_ERRORS_POST_PAYMENT'
export const ACCT_SET_SELECTED_ACCOUNT = 'ACCT_SET_SELECTED_ACCOUNT'
export const ACCT_SET_SELECTED_ACCOUNT_ACTIVITY = 'ACCT_SET_SELECTED_ACCOUNT_ACTIVITY'
export const ACCT_SET_SELECTED_ACCOUNT_CORRESPONDENCES = 'ACCT_SET_SELECTED_ACCOUNT_CORRESPONDENCES'
export const ACCT_SET_SELECTED_ACCOUNT_EQUIP = 'ACCT_SET_SELECTED_ACCOUNT_EQUIP'
export const ACCT_SET_SELECTED_ACCOUNT_FORMS = 'ACCT_SET_SELECTED_ACCOUNT_FORMS'
export const ACCT_SET_SELECTED_ACCOUNT_INVOICES = 'ACCT_SET_SELECTED_ACCOUNT_INVOICES'
export const ACCT_SET_SELECTED_ACCOUNT_UNPAID_INVOICES = 'ACCT_SET_SELECTED_ACCOUNT_UNPAID_INVOICES'
export const ACCT_SET_SELECTED_ACCOUNT_RATES = 'ACCT_SET_SELECTED_ACCOUNT_RATES'
export const ACCT_SET_SELECTED_ACCOUNT_SERVICES = 'ACCT_SET_SELECTED_ACCOUNT_SERVICES'
export const ACCT_SET_SELECTED_ACCOUNT_TKTS = 'ACCT_SET_SELECTED_ACCOUNT_TKTS'
export const ACCT_SET_SELECTED_ACCOUNT_USERS = 'ACCT_SET_SELECTED_ACCOUNT_USERS'
export const ACCT_UPDATE_SELECTED_ACCOUNT = 'ACCT_UPDATE_SELECTED_ACCOUNT'
export const ACCT_UPDATE_SELECTED_ACCOUNT_UNPAID_INV = 'ACCT_UPDATE_SELECTED_ACCOUNT_UNPAID_INV'
export const ACCT_SET_IS_UPDATINGPAYMENTDETAILS = 'ACCT_SET_IS_UPDATINGPAYMENTDETAILS'
export const ACCT_SET_IS_POSTINGPAYMENT = 'ACCT_SET_IS_POSTINGPAYMENT'
export const ACCT_SET_IS_GETTINGACCOUNT = 'ACCT_SET_IS_GETTINGACCOUNT'
export const ACCT_SET_IS_GETTINGACCOUNTINVOICES = 'ACCT_SET_IS_GETTINGACCOUNTINVOICES'
export const ACCT_SET_IS_GETTINGACCOUNTS = 'ACCT_SET_IS_GETTINGACCOUNTS'

export const AUTH_SET_LOGIN = 'AUTH_SET_LOGIN'
export const AUTH_RESET_LOGIN = 'AUTH_RESET_LOGIN'

export const CUST_SET_SEARCH_RESULTS = 'CUST_SET_SEARCH_RESULTS'
export const CUST_SET_SEARCH_QUERY = 'CUST_SET_SEARCH_QUERY'
export const CUST_SET_USE_CACHE = 'CUST_SET_USE_CACHE'
export const CUST_RESET_SEARCH = 'CUST_RESET_SEARCH'

export const PUBLIC_SET_PLANS = 'PUBLIC_SET_PLANS'
export const PUBLIC_RESET_PLANS = 'PUBLIC_RESET_PLANS'

export const FORM_SET_FORMS = 'FORM_SET_FORMS'

export const FORM_RESULT_SET_RESULT = 'FORM_RESULT_SET_RESULT'
export const FORM_RESULT_RESET_RESULT = 'FORM_RESULT_RESET_RESULT'
export const FORM_RESULT_SET_RESULTS = 'FORM_RESULT_SET_RESULTS'
export const FORM_RESULT_RESET_RESULTS = 'FORM_RESULT_RESET_RESULTS'

export const PLAN_ADD_PLAN = 'PLAN_ADD_PLAN'
export const PLAN_RESET_PLANS = 'PLAN_RESET_PLANS'
export const PLAN_SET_ACTIVE = 'PLAN_SET_ACTIVE'

export const SEARCH_SET_FILTERS = 'SEARCH_SET_FILTERS'
export const SEARCH_SET_QUERY = 'SEARCH_SET_QUERY'
export const SEARCH_SET_RESULTS = 'SEARCH_SET_RESULTS'
export const SEARCH_UNSHIFT_SEARCHES = 'SEARCH_UNSHIFT_SEARCHES'
export const SEARCH_SET_USE_CACHE = 'SEARCH_SET_USE_CACHE'
export const SEARCH_SET_ENABLED_FILTERS = 'SEARCH_SET_ENABLED_FILTERS'

export const SIGNUP_SET_AVAIL_PLANS = 'SIGNUP_SET_AVAIL_PLANS'
export const SIGNUP_RESET_LOCATION = 'SIGNUP_RESET_LOCATION'
export const SIGNUP_RESET_SIGNUP = 'SIGNUP_RESET_SIGNUP'
export const SIGNUP_RESET_ACTIVE_SIGNUP = 'SIGNUP_RESET_ACTIVE_SIGNUP'
export const SIGNUP_SET_ACCOUNT_HOLDER = 'SIGNUP_SET_ACCOUNT_HOLDER'
export const SIGNUP_SET_ACTIVE_SIGNUP = 'SIGNUP_SET_ACTIVE_SIGNUP'
export const SIGNUP_SET_ACTIVE_SIGNUP_STATUS = 'SIGNUP_SET_ACTIVE_SIGNUP_STATUS'
export const SIGNUP_SET_CHECKING_STATUS = 'SIGNUP_SET_CHECKING_STATUS'
export const SIGNUP_SET_BILLING_HOLDER = 'SIGNUP_SET_BILLING_HOLDER'
export const SIGNUP_SET_QUESTIONNAIRE_VALUES = 'SIGNUP_SET_QUESTIONNAIRE_VALUES'
export const SIGNUP_SET_ADDON_VALUES = 'SIGNUP_SET_ADDON_VALUES'
export const SIGNUP_SET_LOCATION = 'SIGNUP_SET_LOCATION'
export const SIGNUP_SET_LOCATION_MARKER = 'SIGNUP_SET_LOCATION_MARKER'
export const SIGNUP_SET_SELECTED_PLAN = 'SIGNUP_SET_SELECTED_PLAN'
export const SIGNUP_SET_FORM_STEP = 'SIGNUP_SET_FORM_STEP'

export const TOWER_SET_TOWERS = 'TOWER_SET_TOWERS'
export const TOWER_SET_TOWER_APS = 'TOWER_SET_TOWER_APS'
export const TOWER_SET_TOWER_SUBS = 'TOWER_SET_TOWER_SUBS'

export const USER_SET_USERS = 'USER_SET_USERS'
export const USER_SET_UPDATE_ERRORS = 'USER_SET_UPDATE_ERRORS'
